<template>
	<div class="outerBox" ref="outerDom" @scroll="getScrollTop">
		<div class="home">
			<headNav :activeMenu="1"></headNav>
			<div class="homeContent">
				<div class="banner">
					<div class="banner_content width-140 margin-a">
						<div class="font-bold banner-title">武清区中小企业数字化转型公共服务平台</div>
						<div class="fontStyle24 banner-text">
							<span class="mobile-hide">面向智能制造装备、先进交通装备及关键零部件、时尚健康消费品制造三大细分行业，</span><br>
							加快数字化发展、建设数字企业<span class="mobile-hide">,</span><br class="pc-hide" />推进中小企业数字化转型
						</div>
					</div>
					<div class="bannerBtnBox fontStyle20">
						<div class="bannerBtn"
							:class="[!userToken ? '' : userRole == 2 || userRole == 3 || userRole == 4 || userRole == 5 ? 'disable-btn' : '']"
							@click="checkLogin(1)">试点企业 快速入口</div>
						<div class="bannerBtn"
							:class="[!userToken ? '' : userRole == 1 || userRole == 3 || userRole == 4 || userRole == 5 ? 'disable-btn' : '']"
							@click="checkLogin(2)" style="margin-left:0.3rem">服务商 快速入口</div>
					</div>
					<div class="animate-word fontStyle16 width-140 margin-a font-bold">
						<img src="../assets/homepage/notice.png" alt="">
						<div class="text-container">
							<div class="animate-text" @click="getPolicyInfo2">
								武清区中小企业数字化转型公共服务平台新版域名上线通知
								<span style="font-size: 12px;color: #999;margin-left: 12px;">2025-10-30</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mainContent width-140 margin-a fontStyle20">
					<div class="statistics">
						<div class="statisticsBox" v-for="(item, index) in statisticsList" :key="'statistics'+index">
							<div class="statistics_info">
								<div class="statistics_info_value fontSize30 font-bold" v-if="index == 3">{{ item.value }}</div>
								<div class="statistics_info_value fontSize30 font-bold" v-if="index == 0 || index == 1 || index == 2">
									<countTo class="count-to" :startVal='0' :endVal='Number(item.value)' :duration='3000'></countTo>
								</div>

								<div class="statistics_info_title fontSize20">{{ item.title }}</div>
							</div>
							<img :class="index == 0 || index == 1 ? 'statistics_icon' : 'statistics_icon2'" :src="item.icon" alt="">
							<div v-if="index != 3" class="verticalLine"></div>
						</div>
					</div>
					<div class="noticeBox">
						<div class="notice_middle">
							<el-carousel class="mobile-hide" height="3.25rem" :interval="5000">
								<el-carousel-item class="carousel-item">
									<img @click="pagePolicy" src="../assets/homepage/carousel-policy.png" alt="">
								</el-carousel-item>
								<el-carousel-item class="carousel-item">
									<img @click="pageToEnterpriseTable" src="../assets/homepage/carousel-sd.jpg" alt="">
								</el-carousel-item>
								<el-carousel-item class="carousel-item">
									<img @click="pageToServiceTable" src="../assets/homepage/carousel-fw.jpg" alt="">
								</el-carousel-item>
								
							</el-carousel>
							<el-carousel class="pc-hide" height="2.25rem" type="card" 
							:autoplay="false" indicator-position="none" arrow="never">
								<el-carousel-item class="carousel-item">
									<img @click="pagePolicy" src="../assets/homepage/carousel-policy.png" alt="">
								</el-carousel-item>
								<el-carousel-item class="carousel-item">
									<img @click="pageToEnterpriseTable" src="../assets/homepage/carousel-sd.jpg" alt="">
								</el-carousel-item>
								<el-carousel-item class="carousel-item">
									<img @click="pageToServiceTable" src="../assets/homepage/carousel-fw.jpg" alt="">
								</el-carousel-item>
								
							</el-carousel>
							<!-- <div class="hotspotBox">
								<div class="hotspotTitle mobile-hide">政策公告</div>
								<div class="hotspotTitleMobile pc-hide">政<br />策<br />公<br />告</div>
							</div> -->
						</div>
						<div class="notice_right">
							<!-- 政策通知，工作动态，新闻中心 -->
							 <div class="tab-title mobile-hide">
								<div :class="policyTab == 1?'tab-active':''" @click="pagePolicy" @mouseenter="changeTab(1)">政策通知</div>
								<div :class="policyTab == 2?'tab-active':''" @click="pageCenter(2)" @mouseenter="changeTab(2)">工作动态</div>
								<div :class="policyTab == 3?'tab-active':''" @click="pageCenter(3)" @mouseenter="changeTab(3)">新闻中心</div>
							 </div>
							 <div class="pc-hide">
								<div class="tab-title ">
									<div :class="policyTab == 1?'tab-active':''" @click="changeTab(1)">政策通知</div>
									<div :class="policyTab == 2?'tab-active':''" @click="changeTab(2)">工作动态</div>
									<div :class="policyTab == 3?'tab-active':''" @click="changeTab(3)">新闻中心</div>
								</div>
							 </div>
							 
							 <div v-for="(item, index) in showNewsList" @click="getPolicyInfo(item)" class="row justify-between news-item"
									:title="item.title" :key="'policy' + index">
										<div class="news-title-div webkit-line-1 fontStyle18 font-bold">{{ item.title }}</div>
										<div class="news-view fontStyle16"> <i class="el-icon-date"></i> {{ item.releaseDate.slice(0, 10) }} </div>
										<!-- <div class="news-click fontStyle16">
											<img src="../assets/homepage/view-icon.png" alt="">{{ item.clickRate }}
										</div> -->
									<!-- <div class="news-intro fontStyle16 webkit-line-1">{{ item.releaseDate.slice(0, 10) }}</div> -->
								</div>
								<div @click="pageToNext" class="pc-hide viewMore">查看更多>></div>
							<!-- <div class="viewMore" @click="pagePolicy">查看更多 >></div> -->
							<!-- <div class="notice_scroll">
								<div v-for="(item, index) in newsList" @click="getPolicyInfo(item)" class="news-item"
									:title="item.title" :key="'policy' + index">
									<div class="news-title row justify-between">
										<div class="news-title-div webkit-line-1 fontStyle18 font-bold">{{ item.title }}</div>
										<div class="news-view fontStyle16"><img src="../assets/homepage/view-icon.png" alt="">{{
											item.clickRate }}
										</div>
									</div>
									<div class="news-intro fontStyle16 webkit-line-1">{{ item.releaseDate.slice(0, 10) }}</div>
								</div>
							</div> -->
						</div>
					</div>
					<div class="gydt">
						<!-- 195流程修改测试 -->
						<!-- <div class="more-btn fontStyle16" @click="pageToSupply">查看更多&gt;&gt;</div> -->
						<div class="more-btn fontStyle16" @click="pageToSupply">查看更多&gt;&gt;</div>
						<div class="model-title row items-end">
							<div class="fontStyle30 font-bold" style="letter-spacing: 5px;">供应大厅</div>
							<div class="fontStyle20 sub-title">为企业提供数字服务，助企数字化转型</div>
						</div>
						<div class="gydt-search row items-center">
							<div class="search-key fontStyle20">场景：</div>
							<div class="search-item fontStyle16 row items-center justify-center pc-hide" @click="gydtCjClick(item)"
								v-for="(item, index) in cjList" :key="'cj'+index" :class="{ 'cj-active': cjActive == item.value }"
								v-html="item.name"></div>
							<div class="search-item fontStyle16 row items-center justify-center mobile-hide"
								@click="gydtCjClick(item)" v-for="(item, index) in cjList" :key="index"
								:class="{ 'cj-active': cjActive == item.value }" v-html="item.name"></div>
						</div>
						<div class="gydt-search row items-center">
							<div class="search-key fontStyle20">行业：</div>
							<div class="search-item fontStyle16 row items-center justify-center mobile-hide"
								@click="gydtHyClick(item)" v-for="(item, index) in hyList" :key="'hy'+index"
								:class="{ 'cj-active': hyActive == item.value }" v-html="item.name"></div>
							<div class="search-item fontStyle16 row items-center justify-center pc-hide" @click="gydtHyClick(item)"
								v-for="(item, index) in hyListMobile" :key="index" :class="{ 'cj-active': hyActive == item.value }"
								v-html="item.name"></div>

						</div>
						<div class="row items-center gydt-box" v-if="cpList.length > 0">
							<div class="gydt-item" v-for="(item, index) in cpList" :key="'cp'+index" @click="getSupplyInfo(item)">
								<div class="gydt-clip relative-position">
									<!-- <div class="gy-img" style="background: pink;"></div> -->
									<img class="gy-img" :src="item.img" alt="">
									<div class="gy-lxfs row items-center absolute-position fontStyle16"><img
											src="../assets/homepage/lxfs.png" />{{ item.contactPhone }}</div>
								</div>
								<div class="product-padd">
									<div class="row items-center flex-row fontStyle14">
										<span
											:class="['supply-hylx', 'fontStyle14', 'hylx' + (ele == '先进交通装备及关键零部件' ? '1' : ele == '时尚健康消费品制造' ? '2' : ele == '智能制造装备' ? '3' : '0')]"
											:title="ele" v-for="(ele, idx) in item.industryTypeArrList" :key="idx">
											<p>{{ ele }}</p>
										</span>
									</div>
									<div class="product-name fontStyle24 font-bold webkit-line-1">{{ item.softwareName }}</div>
									<div class="product-intro fontStyle14 webkit-line-2">服务介绍：{{ item.sofDes }}</div>
									<div class="product-intro fontStyle14 webkit-line-1">服务场景：{{ item.serviceSceneArrTxt }}</div>
									<div class="product-intro fontStyle14 webkit-line-1">公司名称：{{ item.enterpriseName }}</div>
									<div class="product-intro fontStyle14">产品价格：
										<span class="product-blue fontStyle18" v-if="item.priceType == 2">¥ {{ item.priceRangeMin }} - {{
											item.priceRangeMax }} 万元</span>
										<span class="product-blue fontStyle18" v-if="item.priceType == 1">¥ {{ item.priceRangeMin }}
											万元</span>
									</div>
								</div>

							</div>
						</div>
						<div class="noData1" v-if="cpList.length == 0">
							<img src="../assets/homepage/no-data.png" alt="">
							<div class="noDataText fontStyle18" style="margin-top: 0.3rem;">暂无数据</div>
						</div>
					</div>

					<!-- <div class="login-btngroup row items-center justify-between">
						<div @click="loginFunc(1)" class="login-groupdiv fontStyle26 font-bold row items-center justify-center">
							<img style="width:0.7rem;height:0.6rem;" src="../assets/homepage/sdqy-icon.png" alt="">
							<span>试点企业登录</span>
						</div>
						<div @click="loginFunc(2)" class="login-groupdiv fontStyle26 font-bold row items-center justify-center">
							<img style="width:0.6rem;height:0.5rem;" src="../assets/homepage/fws-icon.png" alt="">
							<span>服务商登录</span>
						</div>
						<div @click="loginFunc" class="login-groupdiv fontStyle26 font-bold row items-center justify-center">
							<img style="width:0.53rem;height:0.5rem;" src="../assets/homepage/fwjg-icon.png" alt="">
							<span>监理机构登录</span>
						</div>
						<div @click="loginFunc" class="login-groupdiv fontStyle26 font-bold row items-center justify-center">
							<img style="width:0.53rem;height:0.58rem;" src="../assets/homepage/zfzb-icon.png" alt="">
							<span>政府专班登录</span>
						</div>
					</div> -->
				</div>
				<div class="zzfw">
					<div class="model-title row items-end width-140 margin-a fontStyle20 relative-position">
						<div class="more-btn fontStyle16" @click="pageToServiceTable">查看更多&gt;&gt;</div>
						<div class="fontStyle30 font-bold" style="letter-spacing: 5px;">合作服务商</div>
						<div class="fontStyle20 sub-title">协同多行业服务伙伴，为企业提供全面且高质量的数转服务</div>
					</div>
					<div class="noData width-140 margin-a" v-if="!(serviceEnterList.length > 0 || serviceEnterList2.length > 0)"
						style="background: #fff;border-radius: 15px;">
						<img src="../assets/homepage/no-data.png" alt="">
						<div class="noDataText fontStyle18">暂无数据</div>
					</div>
					<div v-if="serviceEnterList.length > 0 || serviceEnterList2.length > 0" class="mobile-hide">
						<seamless-scroll class="service-enter-list" key="serviceEnterList" :data="serviceEnterList"
							:class-option="scrollClass">
							<ul class="row scroll-ul fontStyle20">
								<li class="scroll-li" v-for="(item, index) in serviceEnterList" :key="'service'+index">
									<div class="service-logo" 
									:style="{ backgroundImage: getBackgroundImage(item),backgroundSize:item.logo == '' || item.logo == null?'100% 100%':'contain' }">
										<div class="webkit-line-1 enter-name" v-if="item.logo == '' || item.logo == null">{{ item.enterpriseName }}</div>

										<!-- <img :src="imgUrl + item.logo" v-if="!(item.logo == '' || item.logo == null)" alt=""> -->
										<!-- <div class="no-logo fontStyle48 font-bold row items-center justify-center" v-else>LOGO</div> -->
										 <!-- <img src="@/assets/homepage/logo-bg.png" v-else alt=""> -->
									</div>
								</li>
							</ul>
						</seamless-scroll>
						<seamless-scroll v-if="serviceEnterList2.length > 0" class="service-enter-list1" key="serviceEnterList2"
							:data="serviceEnterList2" :class-option="scrollClass2">
							<ul class="row scroll-ul fontStyle20">
								<li class="scroll-li" v-for="(item, index) in serviceEnterList2" :key="'service2'+index">
									<div class="service-logo"
									 :style="{ backgroundImage: getBackgroundImage(item),backgroundSize:item.logo == '' || item.logo == null?'100% 100%':'contain' }">
									 <div class="webkit-line-1 enter-name" v-if="item.logo == '' || item.logo == null">{{ item.enterpriseName }}</div>
										<!-- <img :src="imgUrl + item.logo" v-if="!(item.logo == '' || item.logo == null)" alt=""> -->
										<!-- <div class="no-logo fontStyle48 font-bold row items-center justify-center" v-else></div> -->
										 <!-- <img src="@/assets/homepage/logo-bg.png" v-else alt=""> -->
									</div>
								</li>
							</ul>
						</seamless-scroll>
					</div>
					<div class="pc-hide">
						<el-carousel height="2.5rem" :autoplay="true" indicator-position="none" style="padding:0 20px;">
							<el-carousel-item v-for="(item, index) in mobileList" :key="'carousel' + index" class="row flex-wrap justify-between">
								<li class="scroll-li fontStyle14" v-for="(ele, idx) in item" :key="'item'+idx">
									<div class="service-logo" :style="{ backgroundImage: getBackgroundImage(ele),backgroundSize:ele.logo == '' || ele.logo == null?'100% 100%':'contain' }">
										<div class="webkit-line-1 enter-name" v-if="ele.logo == '' || ele.logo == null">{{ ele.enterpriseName }}</div>
										<!-- <img :src="imgUrl + ele.logo" v-if="!(ele.logo == '' || ele.logo == null)" alt=""> -->
										<!-- <div class="no-logo fontStyle48 font-bold row items-center justify-center" v-else>LOGO</div> -->
										 <!-- <img src="@/assets/homepage/logo-bg.png" v-else alt=""> -->
									</div>
								</li>
							</el-carousel-item>
						</el-carousel>
					</div>


				</div>
				<!-- <div class="fws-mobile" @mouseenter="mobileShow = true" @mouseleave="mobileShow = false">
					<img src="@/assets/homepage/lxfs-fws.png" alt="">
				</div> -->
				<div class="fws-mobileinfo" v-if="mobileShow">
					<div class="info-title">综合服务商咨询电话</div>
					<div class="info-li">
						<div class="li-name">北京中软国际信息技术有限公司</div>
						<div class="li-mobile">
							<el-icon class="el-icon-phone-outline"></el-icon>
							<span>158-9585-1313（海伦）</span>
						</div>
					</div>
					<div class="info-li">
						<div class="li-name">联通数字科技有限公司</div>
						<div class="li-mobile">
							<el-icon class="el-icon-phone-outline"></el-icon>
							<span>156-2001-1102（王维强）</span>
						</div>
					</div>
					<div class="info-li">
						<div class="li-name">忽米数智（天津）科技有限公司</div>
						<div class="li-mobile">
							<el-icon class="el-icon-phone-outline"></el-icon>
							<span>185-2347-9816（李映萱）</span>
						</div>
					</div>
					<div class="info-li">
						<div class="li-name">蚂蚁雄兵（天津）科技发展有限公司</div>
						<div class="li-mobile">
							<el-icon class="el-icon-phone-outline"></el-icon>
							<span>187-2211-7502（刘阳）</span>
						</div>
					</div>
					<div class="info-li">
						<div class="li-name">中电信数智科技有限公司天津分公司</div>
						<div class="li-mobile">
							<el-icon class="el-icon-phone-outline"></el-icon>
							<span>189-2037-7337（李松）</span>
						</div>
					</div>
					<div class="info-li">
						<div class="li-name">浪潮云洲工业互联网有限公司</div>
						<div class="li-mobile">
							<el-icon class="el-icon-phone-outline"></el-icon>
							<span>138-2175-4125（丁浩然）</span>
						</div>
					</div>
				</div>
			</div>
			<bottom></bottom>
			<el-dialog class="fontStyle16 dhzx" custom-class="transparent-dialog" title="提示" width="200px"
				:visible.sync="dialogVisible">
				<span class="fontStyle14">电话：12121222</span>
			</el-dialog>
		</div>
		<div class="scrollBox" v-show="isShow" @click="goBack"></div>
	</div>
</template>

<script>
import logoBg from '@/assets/homepage/logo-bg.png'; // 导入本地图片资源
import headNav from '@/components/headNav.vue'
import bottom from '@/components/bottom.vue'
import SeamlessScroll from 'vue-seamless-scroll';
import { getDictLabel, getTreeLabel } from '@/utils/index'
import utils from '@/utils/utils'
// import backTop from '@/components/backTop.vue'
import { formatDate, getcpTypeName,downloadFileByToken } from '@/utils/index'
import he from "he";
import { AESDecrypt } from '@/utils/secret';
import Cookies from "js-cookie";
import countTo from 'vue-count-to'
export default {
	name: 'home',
	components: {
		countTo,
		headNav,
		bottom,
		SeamlessScroll
		// backTop
	},
	data() {
		return {
			mobileShow:false,
			pageshow: false,
			imgUrl: this.$url.imageUrl,
			serviceEnterList: [],
			serviceEnterList2: [],
			mobileList:[],
			scrollClass: {
				'scroll-item': true,
				direction: 2,// 0向下 1向上 2向左 3向右
				step: 0.5// 数值越大速度滚动越快
			},
			scrollClass2: {
				'scroll-item': true,
				direction: 3,// 0向下 1向上 2向左 3向右
				step: 0.5// 数值越大速度滚动越快
			},
			userRole: Cookies.get('userInfo') ?
				JSON.parse(Cookies.get('userInfo')).type : null,
			cjList: [
				{ name: '全部', value: 0 },
				{ name: '诊断咨询设计', value: 1 },
				{ name: '数字化基础设施', value: 2 },
				{ name: '解决方案', value: 3 },
				{ name: '其他', value: 4 },
			],
			cjActive: 0,
			hyActive: 0,
			hyList: [
				{ name: '全部', value: 0 },
				{ name: '智能制造装备', value: 1 },
				{ name: '先进交通装备<br>及关键零部件', value: 2 },
				{ name: '时尚健康消费品<br>制造', value: 3 },
				{ name: '其他', value: 4 },
			],
			hyListMobile: [
				{ name: '全部', value: 0 },
				{ name: '智能制造装备', value: 1 },
				{ name: '先进交通装备及关键零部件', value: 2 },
				{ name: '时尚健康消费品制造', value: 3 },
				{ name: '其他', value: 4 },
			],
			cpList: [],
			zzList: [
				{
					name: '金融服务',
					subTxt: '与金融机构合作，促进实体经济的发展，提升金融服务的质量和效率，实现经济高质量发展的目标',
					type: 1
				},
				{
					name: '数字服务',
					subTxt: '融合政策云计算，提高政策制定和执行效率和质量，推动数字政府的建设，提升政府服务水平和社会治理能力',
					type: 2
				},
				{
					name: '法律服务',
					subTxt: '提供专业高效的法律解决方案，助力企业构建稳固的法律基础，有效预防法律风险，保障企业运营安全',
					type: 3
				},
				{
					name: '培训服务',
					subTxt: '提供产品设计、研发、制造和管理方面培训机会，为企业和行业培养更多专业人才，推动产业和经济持续发展',
					type: 4
				},
			],
			zzfwActive: 4,

			serviceList1: [
				{
					title: '金融服务课程标题文字',
					intro: '金融服务课程内容介绍文字金融服 务课程内容介绍文字金融服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '金融服务课程标题文字',
					intro: '金融服务课程内容介绍文字金融服 务课程内容介绍文字金融服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '金融服务课程标题文字',
					intro: '金融服务课程内容介绍文字金融服 务课程内容介绍文字金融服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '金融服务课程标题文字',
					intro: '金融服务课程内容介绍文字金融服 务课程内容介绍文字金融服务课...',
					time: '2024-09-02 16:42',
				}
			],
			serviceList2: [
				{
					title: '数字服务课程标题文字',
					intro: '数字服务课程内容介绍文字数字服 务课程内容介绍文字数字服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '数字服务课程标题文字',
					intro: '数字服务课程内容介绍文字数字服 务课程内容介绍文字数字服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '数字服务课程标题文字',
					intro: '数字服务课程内容介绍文字数字服 务课程内容介绍文字数字服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '数字服务课程标题文字',
					intro: '数字服务课程内容介绍文字数字服 务课程内容介绍文字数字服务课...',
					time: '2024-09-02 16:42',
				}
			],
			serviceList3: [
				{
					title: '法律服务课程标题文字',
					intro: '法律服务课程内容介绍文字法律服 务课程内容介绍文字法律服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '法律服务课程标题文字',
					intro: '法律服务课程内容介绍文字法律服 务课程内容介绍文字法律服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '法律服务课程标题文字',
					intro: '法律服务课程内容介绍文字法律服 务课程内容介绍文字法律服务课...',
					time: '2024-09-02 16:42',
				},
				{
					title: '法律服务课程标题文字',
					intro: '法律服务课程内容介绍文字法律服 务课程内容介绍文字法律服务课...',
					time: '2024-09-02 16:42',
				}
			],
			serviceList4: [
				{
					img: require('../assets/homepage/pximg1.png'),
					title: '工业和信息化部：“点线面”一体化推进数字化转型',
					time: '2024-09-02 16:42',
				},
				{
					img: require('../assets/homepage/pximg2.png'),
					title: '《中国城市数字经济论坛》数字经济与城市高质量发展',
					time: '2024-09-02 16:42',
				},
				{
					img: require('../assets/homepage/pximg3.png'),
					title: '首届链博会：“数字科技链”',
					time: '2024-09-02 16:42',
				},
				{
					img: require('../assets/homepage/pximg4.png'),
					title: '国资委：全面实施国有企业数字化转型行动计划',
					time: '2024-09-02 16:42',
				},
			],
			serviceList: [],
			scrollTop: 0, //默认距离顶部的距离
			isShow: false, //控制返回顶部按钮的显隐
			scrollTrigger: false, //默认初始值
			// userName: window.localStorage.getItem('userName') ? window.localStorage.getItem('userName') : '',
			value: new Date(),

			activeXm: -1,
			dialogVisible: false,

			enterSum: 0,
			qyNum: 0,
			fwjgNum: 0,
			policyTab: 1,
			newsList: [],
			workList: [],
			policyList:[],
			showNewsList:[],
			statisticsList: [{
				title: '浏览量（次）',
				value: '0',
				icon: require('../assets/homepage/statistics_Icon1.png')
			}, {
				title: '入库企业（家）',
				value: '0',
				icon: require('../assets/homepage/statistics_Icon2.png')
			}, {
				title: '服务商（家）',
				value: '0',
				icon: require('../assets/homepage/statistics_Icon3.png')
			}, {
				title: '产品解决方案数（个）',
				value: '0',
				icon: require('../assets/homepage/statistics_Icon4.png')
			}],
			noticeList: [{
				title: '政策公告',
				icon1: require('../assets/homepage/notice_zcIcon1.png'),
				icon2: require('../assets/homepage/notice_zcIcon2.png')
			}, {
				title: '工作动态',
				icon1: require('../assets/homepage/notice_dtIcon1.png'),
				icon2: require('../assets/homepage/notice_dtIcon2.png')
			}, {
				title: '新闻中心',
				icon1: require('../assets/homepage/notice_xwIcon1.png'),
				icon2: require('../assets/homepage/notice_xwIcon2.png')
			}],
			userToken: Cookies.get("token"),
			sdNum: 12,
			scenceOptions: utils.serverScence,
		}
	},
	mounted() {
		//let str = "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"
		//console.log(AESDecrypt(str))
		//let str1 = "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"
		//console.log(AESDecrypt(str1))
		// let str2 = '5163f8a4cf7994a52c134d21f7347d9515ef6ebb9dcd8b3d473a4524e87cc986674306863a9e6f595aa1226d4bfd5735d107bb4b7ff936d4721898a1407e0a6f211c68ca58bd802a71930e8ad65d85a3290b5afb2cd3c31d3add25ae74f68202d22250f7559b5d8bcc3328e370fda9c0f43cafaec3eb4fe156ae6d50e1cc2d8919a7edc38c415c1fa38cde73b6f8118151a78937533e5cab9868d23b88cdca5b608c2c3728d3291266f4f0d6872582995f5a2e0ea7f549ddc61230d65f0ba5c197f87f033f7790c8569d7f1bc5378d9b7d9d218bf130dda6392d858db56528fe33f66b07e51e0dff9945e2cde02e9f7535d256f566952f3ac86cc41802a292b5ec1a3425dad5504b7e95735e35b178545b79949752893293b93af3c02da261a0a3ad3194c49fd517b31141049357f9b578ce1a6bc32de926d7c62ea7e7764f04e3c155cba7095f298c8676c66aa53b45f16cf8e93faf99238a72d2b2c895b6847fcb5d4648128d83fd74e4d3e29c4dcc8660972c94da09d0303130e443c4a1ebb3acede8ab39404d7bc1596751f64b7b845aa3f93bf1c1818b9aac71e0425e59536f0b3ceae4bb43acce0eebe2ee4b72e6b94e3e2c1ecdc50fe44271d9cc3ac83cb5e119e7b3df2bb3993f8b9d0571a74946fd5fcaa0fa64ba1f6a15a11abd42ba677c2fa3e0067f7a5c43305dfeec48b747564d6aacdd9ce304604783dc05e18c03687fb345c882f9a275ed8e177a353a58fe5e6f0963767ed9190eddbaff46faf65bdc92c1235cd176a5d52bd376c95d53f69b9e650b11b94dd6f7c918db8d65b8b765d6ccff60a7df2ea158bc5d3502e7dc3b225212e1f3426d7a234bd647d1025b9576f7a5f8763af246382a4148a4236ff8e8ce04ce251ac0b62b66f12a7095443b25cc971bf5a2475c95c0536043bbe84b13c35d78a11d972ebfcafcc302884dd025f3971b112a586e41b54f8af475518d83dcec693e21986da05c72a82af981ce2207cce53b19f6e8ae68d9af015226eac406b962efe6d4c53bd5b7ee1d6b9bd5372e397cf3b93b616a6f94611b24b0265695f0ce94eb2cf8089aa0e786ccf2953fd06e030ed9fe4b626cc38ffa73711752abc562d1e604db5dd2eaeec0da3ef11bebce96576a97560b6aa1eaf9577c957572a808da7936f8c5ba229ced7a6b08d300136fd78695093e7f6b1a46653609cd2484d46d9edb9902a70387994f2c55ddd4e7e28aec59c26686870f6eb807b511e64f2ab55e441f5e69e76a8bb5a595049e655c8108c602788a43f67a246357462a6527869446082df94a73275788a4deef258c6fd305f96004dcc871f15df6b5ff146ea3f1761040bd64392561aedbc95dc4bba6530579b05ca523'
		// console.log(AESDecrypt(str2))
		this.serviceList = this.serviceList4
		this.year = new Date().getFullYear().toString()
		var month = new Date().getMonth() + 1
		this.month = month < 10 ? '0' + month : month
		this.month = this.month.toString()
		var date = new Date().getDate()
		this.date = date < 10 ? '0' + date : date
		this.date = this.date.toString()

		this.init()
		// window.onresize = () => {
		//   return (() => {
		//      this.resizeProject(this.enterpriseList.length);
		//   })();
		// };
	},
	computed: {
    getBackgroundImage() {
      return (item) => {
        if (item.logo) {
          return `url(${this.imgUrl + item.logo})`;
        } else {
          return `url(${logoBg})`; // 使用导入的图片资源
        }
      };
    },
  },
	methods: {
		changeTab(index){
			this.policyTab = index
			if(index == 1){
				this.showNewsList = this.policyList
			}else if(index == 2){
				this.showNewsList = this.workList
			}else{
				this.showNewsList = this.newsList
			}
		},
		pageToNext(){
			if(this.policyTab == 1){
				this.pagePolicy()
			}else{
				this.pageCenter(this.policyTab)
			}
		},
		pagePolicy() {
			this.$router.push({
				name: 'policy',
				params: {
					flag:3
				}
			})
		},
		pageCenter(index) {
      sessionStorage.setItem('pageType',index)
			this.$router.push({
				name: 'newsCenter'
			})
		},
		pageToSupply() {
			this.$router.push('/supplyHall')
		},
		pageToServiceTable(){
			this.$router.push('/serviceTable')
		},
		pageToEnterpriseTable(){
			this.$router.push('/enterpriseTable')
		},
		getPolicyInfo(item) {
			// if (this.noticeBtnFlag == 0) {
			this.$router.push({
				path: '/policyInfo',
				query: {
					id: item.id
				}
			})
			// } else {
			// 	this.hope()
			// }

		},
		getPolicyInfo2(){
			this.$router.push({
				path: '/policyInfo',
				query: {
					isNotice: 1
				}
			})
		},
		checkLogin(accountType) {
			if (this.userToken) {
				if (this.userRole == accountType) {
					this.$router.push('/personalCenter')
				} else {
				}
			} else {
				this.$router.push({
					path: '/login',
					name: 'login',
					query: {
						type: 1,
						// accountType: accountType
					},
					params: {
						accountType: accountType
					}
				})
			}
		},
		loginFunc(accountType) {
			this.$router.push({
				path: '/login',
				query: {
					type: 1,
					accountType: accountType
				}

			})
		},
		addView() {
			// 增加浏览量
			this.$api.post('/digital/statisticsNumber/increase').then((res) => { })
		},
		getView() {
			// 获取浏览量
			this.$api.get('/digital/statisticsNumber/info').then((res) => {
				if (res.code == 0) {
					this.statisticsList[0].value = res.data
				}
			})
		},
		init() {
			this.addView()
			this.getView()
			this.getPolicyList()
			this.getGzdt()
			this.getNewsCenter()
			this.getSdEnterNum()
			this.getSupplyList()
			this.getSuperEnter()
		},
		getSuperEnter() {
			this.$api.get(
				'/digital/enterprise/superiorEnterprise',
				{
					params: {
						certified: 1,
						type: 2,
					}
				}
			).then((res) => {
				if (res.code !== 0) {
					this.serviceEnterList = []
					this.serviceEnterList2 = []
					this.mobileList = []
				} else {
					if (res.data.length > 10) {
						this.serviceEnterList = res.data.slice(0, Math.ceil(res.data.length / 2))
						this.serviceEnterList2 = res.data.slice(Math.ceil(res.data.length / 2), res.data.length)
					} else {
						this.serviceEnterList = res.data
						this.serviceEnterList2 = []
					}
					for (let i = 0; i < res.data.length; i += 4) {
							this.mobileList.push(res.data.slice(i, i + 4));
					}
				}

			}).catch(() => {
			})
		},
		getSupplyList() {
			this.$api.get(
				'/digital/product/show/page',
				{
					params: {
						order: 'desc',
						orderField: 'release_date',
						page: 1,
						limit: 3,
						statusDeclare: 2,
						serviceScene: this.cjActive == 0 ? null : this.cjActive,
						industryType: this.hyActive == 0 ? null : this.hyActive,
						isRelease:1,
					}
				}
			).then((res) => {
				if (res.code !== 0) {
					this.cpList = []
				} else {	
					res.data.page.list.forEach(item => {
						let arr = []
						JSON.parse(item.serviceScene).forEach((ele, index) => {
							arr.push(getTreeLabel(this.scenceOptions, ele))
						})
						// let arr2 = []
						// JSON.parse(item.industryType).forEach((ele, index) => {
						//     arr2.push(getDictLabel(this.xfhyType, ele))
						// })
						item.serviceSceneArrTxt = arr.join('，')
						item.industryTypeArrList = JSON.parse(item.industryTypeName)
						item.productImgList = JSON.parse(item.productImg)
						item.img = item.productImgList.length > 0 ? (this.imgUrl + item.productImgList[0].response) : require('../assets/supply/exaimg.png')

					})
					this.cpList = res.data.page.list
					this.statisticsList[3].value = res.data.page.total
				}

			}).catch(() => {
			})
		},
		getSdEnterNum() {
			this.$api.get('/digital/enterprise/getCount').then((res) => {
				if (res.code == 0) {
					res.data.forEach(item => {
						if (item.type == 1) {
							this.statisticsList[1].value = item.total
						} else {
							this.statisticsList[2].value = item.total
						}
					})

				}
			})
		},
		getPolicyList() {
			// 获取政策列表
			this.$api.get(
				'/digital/policy/page',
				{
					params: {
						order: 'desc',
						orderField: 'release_date',
						page: 1,
						limit: 5,
						isRelease: 1,
						type: 1,
						level:3
					}
				}
			).then((res) => {
				if (res.code !== 0) {
					this.policyList = []
				} else {
					this.policyList = res.data.list
					this.showNewsList = this.policyList
					this.total = res.data.total
				}
			}).catch(() => {
			})
		},
		getGzdt(){
			this.$api.get(
				'/digital/policy/page',
				{
					params: {
						order: 'desc',
						orderField: 'release_date',
						page: 1,
						limit: 5,
						isRelease: 1,
						type: 2
					}
				}
			).then((res) => {
				if (res.code !== 0) {
					this.workList = []
				} else {
					this.workList = res.data.list
					this.total = res.data.total
				}
			}).catch(() => {
			})
		},
		getNewsCenter(){
			this.$api.get(
				'/digital/policy/page',
				{
					params: {
						order: 'desc',
						orderField: 'release_date',
						page: 1,
						limit: 5,
						isRelease: 1,
						type: 3
					}
				}
			).then((res) => {
				if (res.code !== 0) {
					this.newsList = []
				} else {
					this.newsList = res.data.list
					this.total = res.data.total
				}
			}).catch(() => {
			})
		},
		showZzfw(item) {
			// this.hope()
			// this.zzfwActive = item.type
			// this.serviceList = this['serviceList' + item.type]
		},
		hope() {
			this.$message.warning('功能开发中，敬请期待')
		},
		gydtCjClick(item) {
			this.cjActive = item.value
			this.getSupplyList()
		},
		gydtHyClick(item) {
			this.hyActive = item.value
			this.getSupplyList()
		},
		userInfo() {
			this.$router.push('/personalCenter')
		},

		getSupplyInfo(item) {
			this.$router.push({
				path: '/supplyInfo',
				query: {
					id: item.id
				}
			})
		},
		// 返回顶部事件
		goBack() {
			let that = this; // 防止this指向问题
			// 防止频繁点击，故返回顶部后设置scrollTrigger为初始值
			if (that.scrollTrigger) {
				return;
			}
			// 获取当前距离顶部的距离
			let scrollTop = this.scrollTop;

			let steep = scrollTop / 2000;
			let timer = setInterval(() => {
				that.scrollTrigger = true;
				// 滚动的速度逐渐变快，第一次走2000/1，然后减去已走的距离，下一次用剩下的距离再减去步进值，步进值也是不断变化，这样速度会越来越快
				scrollTop -= steep;
				// 步进值不改变的话会匀速缓慢上滑，不断增加步进值上滑的距离增加，视觉效果速度变快
				steep += 20;
				if (scrollTop <= 0) {
					clearInterval(timer);
					that.scrollTrigger = false;
				}
				that.$refs.outerDom.scrollTop = scrollTop;
			}, 30);
		},
		// 监听滚动条
		getScrollTop(e) {
			let that = this; // 防止this指向问题
			// 设备一屏的高度
			let clientHeight =
				document.documentElement.clientHeight || document.body.clientHeight;
			let scrollTop = e.srcElement.scrollTop;
			this.scrollTop = scrollTop;
			// 判断距离顶部多少显示回到顶部图标
			if (scrollTop > clientHeight) {
				that.isShow = true;
			} else {
				that.isShow = false;
			}
		},

	}
}
</script>
<style scoped>
.pc-hide{
	display: none;
}
.outerBox {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	overflow-y: auto;
}

/* 返回顶部样式 */
.scrollBox {
	position: fixed;
	right: 10px;
	bottom: 60px;
	font-size: 22px;
	z-index: 99;
	width: 70px;
	height: 70px;
	background: url('../../src/assets/project/backTop.png') no-repeat;
	background-size: 100% 100%;
	cursor: pointer;
}

.scrollBox:hover {
	position: fixed;
	right: 10px;
	bottom: 60px;
	font-size: 22px;
	z-index: 99;
	width: 70px;
	height: 70px;
	background: url('../../src/assets/project/backTop1.png') no-repeat;
	background-size: 100% 100%;
	opacity: 0.6;
}

.scrollBox img {
	width: 100%;
	height: 100%;
	cursor: pointer;
}


.homeContent {
	width: 100%;
	background: #fff url('../assets/homepage/home-bottom.png') no-repeat;
	background-position: bottom;
}

.banner {
	position: relative;
	width: 100%;
	height: 5.28rem;
	background: url('../assets/homepage/banner.png') no-repeat;
	background-size: 100% 100%;
}

.banner_content {
	color: #fff
}

.banner-title {
	font-size: 0.66rem;
	letter-spacing: 0.05rem;
	padding-top: 0.8rem;
	margin-bottom: 0.2rem;
}

.banner-text {
	letter-spacing: 0.03rem;
	/* padding-left: 35px; */
}

.banner .bannerBtnBox {
	position: absolute;
	top: 3.1rem;
	left: 2.55rem;
	display: flex;
}
.animate-word {
	/* width:100%; */
	background: #ffffff4d;
	border-width: 1px 0px 1px 0px;
	border-style: solid;
	border-color: #fff;
	position: absolute;
	left: 50%;
	transform: translate(-50%);
	bottom: 0.1rem;
	overflow: hidden;
	white-space: nowrap;
	height: 0.4rem;
	line-height: 0.4rem;
	display: flex;
	align-items: center;
	padding:0 0.1rem;
	/* transform: translateY(-83px); */
}

.animate-word img {
	width: 0.13rem;
	height: 0.13rem;
}

.text-container {
	width: 100%;
	overflow: hidden;
	white-space: nowrap;
	display: flex;
	align-items: center;
	position: relative;
	height: 0.4rem;
}

.animate-text {
	position: absolute;
	left: 100%;
	letter-spacing:2px;
	animation: scroll 15s linear infinite;
	cursor: pointer;
}
/* .animate-word .animate-text {
	color:#000c;
	display: inline-block;
	position: absolute;
	left: 100%;
	animation: scroll 20s linear infinite;
	vertical-align: middle;
	padding-left: 40px;
} */

@keyframes scroll {
	0% {
		transform: translate(0);
	}

	100% {
		transform: translate(-350%);
	}
}
.banner .bannerBtn {
	width: 2.46rem;
	height: .7rem;
	line-height: .63rem;
	color: #ffffff;
	text-align: center;
	cursor: pointer;
	background: url('../assets/homepage/bannerBtn1.png') no-repeat;
	background-size: 100% 100%;
	font-weight: bold;
}

.banner .bannerBtn:hover {
	background: url('../assets/homepage/bannerBtn2.png') no-repeat;
	background-size: 100% 100%;
}

.banner .bannerBtnbg1 {
	background: url('../assets/homepage/bannerBtn1.png') no-repeat;
	background-size: 100% 100%;
}

.banner .bannerBtnbg2 {
	background: url('../assets/homepage/bannerBtn2.png') no-repeat;
	background-size: 100% 100%;
}

.mainContent {
	/* height: 8rem; */
}

.statistics {
	display: flex;
	align-items: center;
	justify-content: center;

}

.statistics .statisticsBox {
	display: flex;
	align-items: center;
	/* width: 2.09rem; */
	/* height: .97rem; */
}

.statistics .statistics_info {
	min-width: 1.54rem;
}

.statistics .statistics_info_value {
	color: #006FBA;
}

.statistics .statistics_info_title {
	color: #68718B;
}

.statistics .statistics_icon {
	width: .55rem;
	height: .55rem;
	/* background-color: brown; */
}

.statistics .statistics_icon2 {
	width: .47rem;
	height: .56rem;
}

.statistics .verticalLine {
	width: .04rem;
	height: .41rem;
	margin: 0 .45rem;
	background: url('../assets/homepage/verticalLine.png') no-repeat;
	background-size: 100% 100%;
}

.fontSize30 {
	font-size: .3rem;
}

.fontSize24 {
	font-size: .24rem;
}

.noticeBox {
	display: flex;
	/* width: calc(100% - 0.1rem); */
	width: 100%;
	height: 3.25rem;
	margin-top: .5rem;
	/* padding: 0.03rem 0.05rem 0.06rem 0.05rem; */
	/* background: url('../assets/homepage/noticeBoxBg.png') no-repeat;
	background-size: 100% 100%; */
	background: #ffffff;
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
	overflow: hidden;
	border-radius: 0.2rem;
}

.noticeBox .notice_l_btn {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	/* height: 1.56rem; */
	/* font-size: .3rem; */
	cursor: pointer;
}


.margin_bottom13 {
	margin-bottom: .13rem;
}


.notice_middle {
	/* width: calc(4.79rem - 0.53rem);
	height: calc(100% - 0.99rem + 0.3rem);
	padding: .42rem 0.17rem .27rem 0.36rem;
	background: url('../assets/homepage/noticeBg.png') no-repeat;
	background-size: 100% 100%; */
	width: 4.79rem;
	height: 100%;
	position: relative;
	border-radius: 0.2rem 0 0 0.2rem;
	overflow: hidden;
	flex-shrink: 0;
}
.carousel-item img{
	cursor: pointer;
	width: 100%;
	height: 100%;
	transition: transform .25s ease-out;
}

.carousel-item img:hover {
	transform: scale(1.05);
}

.notice_middle .hotspotBox {
	display: flex;
	height: .75rem;
	align-items: center;
	/* background-color: pink; */
}

.policy-hot-title {
	color: #fff;
	cursor: pointer;
	margin-right: 0.1rem;
}

.notice_middle .hotspotIcon {
	width: .32rem;
	height: .40rem;
	margin-right: 0.1rem;
	display: none
}

.notice_middle .hotspotTitle {
	font-size: 0.46rem;
	font-weight: bold;
	/* line-height:0.36rem; */
	color: #ffffff;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	letter-spacing: 5px
}

.notice_middle .hotspotContent {
	width: 2.45rem;
	height: 1.22rem;
	margin-top: 0.3rem;
	font-size: .16rem;
	color: #ffffff;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 4;
	overflow: hidden;
	line-height: 0.24rem;
}

.notice_middle .detailsBtn {
	width: 1.2rem;
	height: .3rem;
	line-height: .3rem;
	text-align: center;
	font-size: .16rem;
	color: #1280F9;
	border: 2px solid #1280F9;
	border-radius: .10rem;
	cursor: pointer;
}

.notice_middle .detailsBtn:hover {
	color: #fff;
	background: #1280F9;
}

.notice_right {
	width: calc(100% - 4.79rem);
	/* flex: 1; */
	/* height: calc(100% - 0.2rem); */
	padding: 0.1rem 0.25rem;
	box-sizing: border-box;
}
.tab-title{
	display: flex;
	justify-content: space-around;
	align-items: center;
	font-size: 0.24rem;
	color: #68718B;
	cursor: pointer;
	
}
.tab-title div{
	text-align: center;
	flex: 1;
	border-bottom: 2px solid #e7e7e7;
	padding-bottom: 0.1rem;
}
.tab-active{
	font-weight: bold;
	color: #1280F9;
	border-bottom: 2px solid #1280F9!important;
}
.notice_right .viewMore {
	text-align: center;
	color: #1280F9;
	font-size: .16rem;
	cursor: pointer;
	margin-top: 0.15rem;
}

.notice_right .viewMore:hover {
	font-weight: bold;
}

.notice_scroll::-webkit-scrollbar {
	display: none
}

.notice_scroll {
	height: calc(100% - 0.4rem);
	overflow: auto;
}

.news-item {
	padding: 0.05rem 0.1rem;
	border-bottom: 1px solid #F4F4F4;
	margin-top: 0.15rem;
}

.news-item:nth-last-child(2) {
	border-bottom: none;
}

.news-item:hover {
	cursor: pointer;
	/* border: 1px solid #cfd1d9; */
}

.news-item:hover .news-title-div {
	color: #1280F9;
}

.news-title-div {
	color: #323232;
	width: 80%;
}

.news-view {
	color: #ACACAC;
	flex-shrink: 0;
	/* width: 10%; */
	text-align: end;
}
.news-click{
	color: #ACACAC;
	width: 10%;
	text-align: left;
}
.news-click img {
	width: 0.14rem;
	height: 0.14rem;
	margin-right: 0.05rem;
}

.news-intro {
	color: #646464;
	margin-top: 0.05rem;
	padding-bottom: 0.05rem;
}

.gydt {
	position: relative;
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
}

.model-title {
	margin-bottom: 0.4rem;

}

.more-btn {
	position: absolute;
	right: 0;
	top: 0;
	width: 1.5rem;
	height: 0.4rem;
	text-align: center;
	line-height: 0.4rem;
	background: linear-gradient(270deg, #0269FF 0%, #1D99FF 100%);
	border-radius: 10px;
	color: #fff;
	cursor: pointer;
}

.more-btn:hover {
	/* font-size: 0.24rem; */
	font-weight: bold;
}

.sub-title {
	color: #68718B;
	margin-left: 0.2rem;
}

.gydt-search {
	margin-bottom: 0.2rem;
}

.search-key {
	color: #006FBA;
}

.search-item {
	width: 1.66rem;
	height: 0.4rem;
	background: linear-gradient(323deg, #E8EFFF 27%, #E4ECFE 72%);
	color: #006FBA;
	border-radius: 8px;
	margin-right: 0.25rem;
	text-align: center;
	padding: 0.07rem 0.1rem;
	cursor: pointer;
}

.cj-active.search-item {
	background: linear-gradient(270deg, #0269FF 0%, #1D99FF 100%);
	color: #fff;
	box-shadow: 3px 3px rgba(0, 0, 0, 0.1);
}

.search-item:hover {
	background: linear-gradient(270deg, #0269FF 0%, #1D99FF 100%);
	color: #fff;
	box-shadow: 3px 3px rgba(0, 0, 0, 0.1);
}

.gydt-box {}

.supply-hylx {
	color: #fff;
	/* padding: 0.07rem 0.08rem; */
	/* width: fit-content; */
	border-radius: 5px;
	margin-right: 0.05rem;
	height: 0.25rem;
	line-height: 0.25rem;
	padding: 0 0.1rem;
}

.supply-hylx p {
	margin: 0;
}

.hylx3 {
	background: #FFAE00;
}

.hylx1 {
	background: #0097FE;
}

.hylx2 {
	background: #00C150;
}

.hylx0 {
	background: #b6bdbd;
}

.gydt-item {
	width: 4.46rem;
	height: 4.8rem;
	margin-right: calc((100% - 4.46rem* 3) / 2);
	background: #fff;
	border-radius: 8px;
	overflow: hidden;

}

.gydt-item:last-child {
	margin-right: 0;
}

.gydt-item .gy-img {
	transition: transform .25s ease-out, -webkit-transform .25s ease-out;
	width: 100%;
	height: 2.5rem;
	border-radius: 8px 8px 0 0;
	clip-path: polygon(0% 0%, 300% 0%, 0% 100%, 0% 100%);
	object-fit: contain;
	/* height */
}

.gydt-item:hover {
	box-shadow: 5px 5px rgba(221, 230, 252, 0.5);
}

.gydt-item:hover .gy-img {
	transform: scale(1.05);
}

.gy-lxfs {
	right: 0.2rem;
	bottom: 0;
	color: #006FBA;
	cursor: pointer;
}

.gy-lxfs:hover {
	font-size: 0.18rem;
}

.gy-lxfs img {
	width: 0.18rem;
	height: 0.18rem;
	margin-right: 0.09rem;
}

.product-type {
	width: fit-content;
	color: #fff;
	padding: 0.05rem 0.07rem;
	background: #0097FE;
	border-radius: 5px;
	box-shadow: 8.17px 16.04px 52px 0px rgba(126, 138, 253, 0.0784);
}

.product-name {
	color: #006FBA;
	margin: 0.1rem 0;
	cursor: pointer;
}

.product-intro {
	color: #68718B;
	margin-bottom: 0.1rem;
}

.product-padd {
	padding: 0 0.2rem;
}

.product-blue {
	color: #0097FE;
}

.scroll-title {
	text-align: center;
	margin-top: 0.5rem;
	margin-bottom: 0.25rem;
}

.scroll-ul {
	list-style: none;
	padding: 0;
}

.scroll-li {
	width: 3rem;
	height: 1rem;
	border-radius: 15px;
	background: #fff;
	text-align: center;
	margin-right: 0.2rem;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
}

.scroll-li:hover {
	/* cursor: pointer; */
	/* margin-top: -0.15rem; */
}

.scroll-li:hover img {
	transform: scale(1.08);
}

.service-logo {
	height: 1rem;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	/* background-size: 100% 100%; */
	background-repeat: no-repeat;
	background-position: center;
}

.scroll-li img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	margin-bottom: 0.05rem;
	transition: transform .25s ease-out;
	border-radius: 15px 15px 0 0;
}

.gydt-clip {
	background: url(../assets/homepage/gydt-bg.png) no-repeat;
	background-size: 100% 100%;
}


.zzfw-item {
	color: #fff;
	margin-right: calc((100% - 8.34rem - 5.1rem) / 3);
	overflow: hidden;
}

.zzfw-item-box {
	width: 2.48rem;
	height: 4.2rem;
	background-size: 100% 100%;
	padding: 0.35rem 0.15rem;
	transition: transform .25s ease-out, -webkit-transform .25s ease-out;
}

.zzfw-item-box:hover {
	transform: scale(1.05);
}

.zzfw-subtxt {
	margin-top: 0.32rem;
	margin-bottom: 0.48rem;
	line-height: 0.3rem;
}

.zzfw-detailbtn {
	width: fit-content;
	border-radius: 8px;
	padding: 0.07rem 0.17rem;
	border: 0.02rem solid #fff;
	cursor: pointer;
}

.zzfw-detailbtn:hover {
	background: #fff;
	color: #006FBA;
}

.zzfw-item:last-child {
	margin-right: 0
}

.zzfw-active {
	/* width: 5.1rem;
	height: 4.9rem; */
	width: 4.48rem;
	height: 4.63rem;
	background: url(../assets/homepage/zzfw-active4.png);
	background-size: 100% 100%;
	padding: 0.15rem 0.27rem 0.12rem 0.35rem;
}

.zzfw-active-more {
	color: #1280F9;
	/* border: 0.02rem solid #1280F9; */
	width: fit-content;
	padding: 0.07rem 0.17rem;
	border-radius: 8px;
	cursor: pointer;
}

.zzfw-active-more:hover {
	/* background: #1280F9; */
	/* color: #fff; */
	font-weight: bold;
}

.zzfw-active-title {
	margin-bottom: 0.2rem;
	color: #333
}

.zzfw-zctive-item {
	width: 1.82rem;
	/* height: 1.2rem; */
	background: rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	padding-left: 0.16rem;
	padding-right: 0.16rem;
	margin-bottom: 0.13rem;
	padding-bottom: 0.1rem;
	border: 1px solid rgba(255, 255, 255, 0.6);
}

.zzfw-zctive-item:hover {
	border: 1px solid #1280F9;
}

.zzfw-zctive-item img {
	width: 100%;
	height: 1rem;
	margin-top: 0.1rem;
	border-radius: 0.1rem 0.1rem 0 0;
}

.zzfw-zctive-item-title {
	margin-top: 0.1rem;
	margin-bottom: 0.05rem;
	color: #333;
}

.zzfw-active-intro {
	margin-bottom: 0.05rem;
}

.color-999 {
	color: #999;
}

.zzfw-zctive-item-more {
	color: #1280F9;
	text-align: center;
	margin-top: 0.05rem;
	/* width: fit-content; */
	cursor: pointer;
}

.zzfw-zctive-item-more:hover {
	text-decoration: underline
}

.zzfw {
	padding-bottom: 0.96rem;
	overflow: hidden;
}

.login-groupdiv {
	width: 3.2rem;
	height: 1.2rem;
	background: url(../assets/homepage/login-btnbg.png);
	background-size: 100% 100%;
	border-radius: 8px;
	cursor: pointer;
	color: #006FBA;
	margin-bottom: 0.5rem;
}

.login-groupdiv:hover {
	background: url(../assets/homepage/login-btnbg-active.png);
	background-size: 100% 100%;
	font-size: 0.32rem;
}

.login-groupdiv img {
	margin-right: 0.2rem;
}

.disable-btn {
	cursor: not-allowed !important;
}

.noData {
	text-align: center;
	box-shadow: 0 0 100px rgb(217 237 255);
	padding: 0.5rem 0;
}

.noData1 {
	text-align: center;
	padding: 0.5rem 0;
}

.noDataText {
	color: #2996ed;
}

.enter-name {
	padding: 0 0.05rem;
	/* position: absolute; */
}

.no-logo {
	width: 50%;
	height: 100%;
	background: #c2e4ff;
	color: #fff;
}
.fws-mobile{
	position: fixed;
	top: 50%;
	transform:translateY(-50%);
	cursor: pointer;
}
.fws-mobile img{
	width: 0.5rem;
	height: 0.5rem;
}
.fws-mobileinfo{
	padding: 10px;
	background: rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	position: fixed;
	top: 50%;
	transform:translateY(-50%);
	left: 0.6rem;
	font-size: 0.16rem;
	color:#fff
}
.info-title{
	text-align: center;
}
.li-mobile span{
	margin-left: 5px;
}
@media only screen and (max-width: 767px) {
	.banner-text {
	padding-left: 35px;
}
	.banner .bannerBtnBox {
		left: 1.55rem;
		top: 3.5rem;
		display: none;
	}

	.banner .bannerBtn {
		width: 3.46rem;
	}

	/* .statistics .statistics_icon {
	width: .85rem;
	height: .85rem;
}

.statistics .statistics_icon2 {
	width: .87rem;
	height: .96rem;
} */
	.fontSize30 {
		font-size: 14px;
	}

	.notice_right {
		width: 100%;
	}

	.notice_right .viewMore {
		font-size: 14px;
	}

	.news-title-div {
		font-weight: normal;
	}

	.banner_content {
		position: absolute;
		top: 38%;
		transform: translateY(-50%);
	}

	.banner {
		padding-top: 30.625%;
		height: unset;
	}

	.banner-title {
		padding: 0;
		display: none;
	}

	.statistics .statistics_info {
		min-width: unset;
		width: 65%;
    text-align: right;
	}

	.statistics .verticalLine {
		display: none;
	}
	.statistics{
		flex-wrap: wrap;
	}
	.statisticsBox{
		width: 50%;
		flex-direction: row-reverse;
		margin-bottom: 10px;
		/* padding-left: 20px; */
		justify-content: center;
		box-sizing: border-box;
	}
	.gydt-box {
		flex-direction: column;
		align-items: start;
	}

	.gydt-item {
		width: 100%;
		height: auto;
		margin-bottom: 10px;
	}

	.model-title {
		/* margin-bottom: 0.4rem; */
		flex-direction: column;
		align-items: baseline;
	}
	.notice_middle .hotspotTitleMobile{
		letter-spacing:normal;
		font-size: 0.46rem;
		font-weight: bold;
		color: #ffffff;
		position: absolute;
    top: 50%;
		transform: translateY(-50%);
	}
	.notice_middle{
		width: 100%;
		height: 2.4rem;
		border-radius: 0.2rem;
		padding-top: 0.1rem;
		box-sizing: border-box;
	} 
	.carousel-item img{
		border-radius: 0.2rem;
	}
	.carousel-item img:hover{
		transform: scale(1);
		border-radius: 0.2rem;
	}
	.tab-title{
		font-size: 0.28rem;
	}
	.noticeBox{
		margin-top: 0.2rem;
		height: auto;
		flex-direction: column;
	}
	.mobile-hide{
		display: none!important;
	}
	.pc-hide{
		display: block;
	}
	.search-item{
		line-height: 0.4rem;
		overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical; */
	}
	.supply-hylx{
		font-size: 12px!important;
		height: 12px;
	}
	.scroll-li{
		margin-bottom: 10px;
		margin-right: 0;
	}
	.scrollBox{
		bottom: 10px;
	}
	.zzfw{
		padding: 10px;
	}
	.fws-mobile{
		top: 30%;
	}
	.sub-title{
		margin-left: 0;
		margin-top: 0.1rem;
	}
}
</style>